module.exports = __webpack_public_path__ + "static/media/spades_8.22b091a7.png";